import { useState } from "react";

const FAQ = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!faqs.length) {
    return null;
  }

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-15 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-5">

        {/* Header */}
        <div className="text-center mb-12">

          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] leading-tight">
            Pertanyaan Umum
          </h2>

          <p className="mt-4 text-[#6B7280] max-w-2xl mx-auto">
            Temukan jawaban atas pertanyaan umum mengenai layanan kami.
          </p>

        </div>

        {/* FAQ */}
        <div className="w-full">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={faq.id || index}>

                {/* Question */}
                <button
                  type="button"
                  onClick={() => toggleFAQ(index)}
                  className={`
                    w-full
                    flex
                    items-center
                    justify-between
                    gap-6
                    px-5
                    md:px-6
                    py-4
                    md:py-5
                    text-left
                    transition-colors
                    duration-200
                    ${
                      isOpen
                        ? "bg-[#E9EEF3]"
                        : "bg-[#F1F1F1] hover:bg-[#EAEAEA]"
                    }
                  `}
                >
                  <span
                    className={`
                      text-sm
                      md:text-base
                      font-semibold
                      ${
                        isOpen
                          ? "text-[#1E3A5F]"
                          : "text-[#374151]"
                      }
                    `}
                  >
                    {faq.question}
                  </span>

                  <span
                    className={`
                      flex-shrink-0
                      text-xl
                      md:text-2xl
                      font-semibold
                      leading-none
                      transition-transform
                      duration-200
                      ${
                        isOpen
                          ? "text-[#1E3A5F] rotate-45"
                          : "text-[#111827]"
                      }
                    `}
                  >
                    +
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`
                    grid
                    transition-all
                    duration-300
                    ${
                      isOpen
                        ? "grid-rows-[1fr]"
                        : "grid-rows-[0fr]"
                    }
                  `}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 md:px-6 py-5 bg-white border-x border-b border-[#E5E7EB] text-sm md:text-base text-[#666] leading-7">
                      {faq.answer}
                    </div>
                  </div>
                </div>

              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FAQ;